import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';
import logo from '../asset/about.jpg'
import { 
  Phone, 
  Mail, 
  MapPin, 
  Clock, 
  Send,
  MessageSquare,
  CheckCircle,
  Facebook,
  Twitter,
  Instagram,
  Linkedin
} from 'lucide-react';
import FAQSection from './FAQSection';
import { Link } from 'react-router-dom';

const Contact = () => {
  
   const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await axios.post('https://backend.ysskytravel.com/api/contact', formData);
      setIsSubmitted(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
    } catch (error) {
      console.error('Error sending message:', error);
      alert('Error sending message. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };
  const contactInfo = [
   
    {
      icon: Mail,
      title:'Email',
      details: ['info@ysskytravel.com'],
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: MapPin,
      title: 'Address',
      details: [ 'Addis Ababa, Jomo 1, Hawdi Mall, 2nd Floor, Office 216'],
      color: 'from-red-500 to-red-600'
    },
   
  ];

  const socialLinks = [
    { icon: Facebook, name: 'Facebook', url: '#', color: 'text-blue-600' },
    { icon: Twitter, name: 'Twitter', url: '#', color: 'text-sky-500' },
    { icon: Instagram, name: 'Instagram', url: '#', color: 'text-pink-600' },
    { icon: Linkedin, name: 'LinkedIn', url: '#', color: 'text-blue-700' }
  ];

  return (
    <div className="min-h-screen">
   <Helmet>
  <title>Contact Us — YS Sky Travel and Tour Agency P.L.C</title>
  <meta name="description" content="Get in touch with YS Sky Travel and Tour Agency P.L.C. We're here to help!" />
</Helmet>

<div className="absolute top-0 left-0 w-full h-32 pointer-events-none 
                bg-gradient-to-b from-white/80 to-transparent 
                dark:from-black/80 z-10"></div>

      {/* Hero Section */}
      <section className="relative h-96 bg-gradient-to-r from-primary-900 via-medical-600 to-blue-600 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={logo}
            alt="Contact us"
            className="w-full h-full object-cover opacity-20"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900/80 to-medical-600/60"></div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
          <div className="text-center w-full animate-fade-in">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Contact Us
            </h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
            feel free to get informations 
            </p>
          </div>
        </div>

        {/* Animated Elements */}
        <div className="absolute top-20 right-20 w-32 h-32 bg-white/10 rounded-full animate-float"></div>
        <div className="absolute bottom-20 left-20 w-24 h-24 bg-white/10 rounded-full animate-float" style={{ animationDelay: '2s' }}></div>
      </section>

      {/* Contact Information Cards */}
      <section className="py-16 bg-white dark:bg-gray-900 transition-colors duration-300 -mt-20 relative z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <Link to={'https://wa.me/251938635555'} target='_blank' 
       
                
                className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 animate-scale-in"
                style={{ animationDelay: ` 0.6s` }}
              >
                <div className={`inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-green-500 to-green-600 rounded-2xl mb-4`}>
                  <Phone size={32} className="text-white" />
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">
                 Phone
                </h3>
                
                <Link to={'https://wa.me/251938635555'} target='_blank' className="space-y-2">
                  
                    <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                      +251 938 625 555
                    </p>
                    <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                      +251 938 635 555
                    </p>
                 
                </Link>
              </Link>
              <a  href="mailto:info@ysskytravel.com" target='_blank' 
       
                
                className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 animate-scale-in"
                style={{ animationDelay: ` 0.6s` }}
              >
                <div className={`inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-blue-500 to-blue-600 rounded-2xl mb-4`}>
                  <Mail size={32} className="text-white" />
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">
                 Email
                </h3>
                
                <a  href="mailto:info@ysskytravel.com" target='_blank' className="space-y-2">
                  
                    <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                      info@ysskytravel.com
                    </p>
                    
                 
                </a>
              </a>
              <Link to={'https://wa.me/251938635555'} target='_blank' 
       
                
                className="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 animate-scale-in"
                style={{ animationDelay: ` 0.6s` }}
              >
                <div className={`inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-green-500 to-green-600 rounded-2xl mb-4`}>
                  <MapPin size={32} className="text-white" />
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">
                Address
                </h3>
                
                <a href="https://maps.app.goo.gl/ZwJDyvAaeSfbdn4S8"  target='_blank' className="space-y-2">
                  
                    <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                     Addis Ababa, Jomo 1, Hawdi Mall, 2nd Floor, Office 216
                    </p>
                    
                 
                </a>
              </Link>
          
          </div>
        </div>
      </section>

      {/* Contact Form and Map */}
       <section className="py-20 bg-gray-50 dark:bg-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Form */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white mb-8">
                Send Us a Message
              </h2>

              {isSubmitted ? (
                <div className="text-center py-12">
                  <div className="bg-green-100 dark:bg-green-900 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
                    <CheckCircle className="h-10 w-10 text-green-600 dark:text-green-400" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Message Sent!</h3>
                  <p className="text-gray-600 dark:text-gray-300">Thank you for contacting us. We'll get back to you soon.</p>
                  <button
                    onClick={() => setIsSubmitted(false)}
                    className="mt-4 text-primary-600 dark:text-primary-400 hover:underline"
                  >
                    Send another message
                  </button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="name" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                        Full Name *
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        required
                        value={formData.name}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-900 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-colors"
                        placeholder="Enter your full name"
                      />
                    </div>

                    <div>
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-900 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-colors"
                        placeholder="Enter your phone number"
                      />
                    </div>
                  </div>

                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Email Address *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-900 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-colors"
                      placeholder="Enter your email address"
                    />
                  </div>

                  <div>
                    <label htmlFor="subject" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Subject *
                    </label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      required
                      value={formData.subject}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-900 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-colors"
                      placeholder="What can we help you with?"
                    />
                  </div>

                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                      Message *
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      rows="6"
                      required
                      value={formData.message}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-900 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-colors resize-none"
                      placeholder="Please describe how we can help you..."
                    ></textarea>
                  </div>

                  <motion.button
                    type="submit"
                    disabled={isSubmitting}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    className="w-full bg-primary-600 hover:bg-primary-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-300 flex items-center justify-center space-x-2 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                    ) : (
                      <>
                        <Send className="w-5 h-5" />
                        <span>Send Message</span>
                      </>
                    )}
                  </motion.button>
                </form>
              )}
            </motion.div>

            {/* Map & Additional Info */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="space-y-8"
            >
              {/* Map Placeholder */}
             <div className="bg-gray-200 dark:bg-gray-700 h-64 rounded-2xl flex items-center justify-center">
  <div className="text-center w-full h-full flex flex-col items-center justify-center ">
    
    <div className="w-full h-full">
      <iframe
       src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31529.07782147943!2d38.683606331839094!3d8.959731081929048!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b81914615651f%3A0xd9f866ab3136345d!2sYS%20Sky%20Travel%20and%20Tour%20Agency%20P.L.C!5e0!3m2!1sen!2set!4v1763170307353!5m2!1sen!2set"
        className="w-full h-full border-0"
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  
  </div>
</div>


          {/* <section className="py-8 bg-white dark:bg-gray-900 transition-colors duration-300">
  <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="text-center mb-6 animate-fade-in">
      <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-2">
        Frequently Asked Questions
      </h2>
      <p className="text-xl text-gray-600 dark:text-gray-400">
        Quick answers to common travel questions
      </p>
    </div>

    <div className="space-y-6">
      {[
        {
          question: 'How can I book a tour or travel service?',
          answer: 'You can book directly through our office in Labu, contact us by phone, or reach us through our online booking channels.'
        },
        {
          question: 'Do you assist with visa processing?',
          answer: 'Yes, we provide complete visa processing support, including document checks, consultation, and submission guidance to ensure a smooth process.'
        },
        {
          question: 'Can I buy airline tickets through your agency?',
          answer: 'Absolutely! We offer airline ticketing for both domestic and international flights, helping you find the best routes and prices.'
        },
        {
          question: 'Do you provide customized tour packages?',
          answer: 'Yes, we create tailor-made tour packages across Ethiopia, Africa, and worldwide destinations based on your interests, budget, and schedule.'
        },
        {
          question: 'What documents do I need for international travel?',
          answer: 'Requirements vary by destination, but you generally need a valid passport, visa (if required), and any necessary travel permits. Our team assists with all document-related inquiries.'
        }
      ].map((faq, index) => (
        <div
          key={index}
          className="bg-gray-50 dark:bg-gray-800 rounded-2xl p-6 animate-fade-in"
          style={{ animationDelay: `${index * 0.1}s` }}
        >
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-3">
            {faq.question}
          </h3>
          <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
            {faq.answer}
          </p>
        </div>
      ))}
    </div>
  </div>
</section> */}
  <FAQSection/>
            </motion.div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
   
    </div>
  );
};

export default Contact;